import axios from 'axios';

//PATCH REQUEST
export const checkBookingWithMailOnYear = (data, type, token) => {
    let newURL = "/booking/check_booking_with_mail_on_year/" + type;
    return axios.post(`${newURL}`, data, {
        headers: { Authorization: token }
    });
}

export const getDataBookingByRequest = (branchID, data, month, token) => {
    let newURL = "/booking/" + branchID + "/get_data_by_request_on_other/" + month;
    return axios.post(`${newURL}`, data, {
        headers: { Authorization: token }
    });
}
